export const canAccessLineIntegration = (firmId, settingAuthority) =>
  Boolean(firmId) && settingAuthority > 0
